export const DATA_ATTRIBUTE_ACTIVE = 'data-show-photo-credit';
const PhotoCreditToggle = (iconSelector: HTMLElement): void => {
  iconSelector.addEventListener('click', (event) => {
    event.preventDefault();

    const icon = event.target as HTMLElement;

    if (icon) {
      const photoCreditWrapper = icon.closest('[data-photo-credit-wrapper]');

      if (photoCreditWrapper) {
        photoCreditWrapper.toggleAttribute(DATA_ATTRIBUTE_ACTIVE);
      }
    }
  });
};

export default PhotoCreditToggle;
